import Booking from '@solvhealth/types/interfaces/Booking';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { UserProfile } from '~/core/dapi/models';
import { getProfileFromBooking } from '~/core/util/account';
import { NewBookingState } from '~/reducers/newBooking';
import { usePaperworkContextBookingId } from '~/routes/paperwork/PaperworkBookingIdContext';
import { InsuranceProfile } from '~/components/Paperwork/hooks/useInsuranceProfiles';

interface PreloadedData {
  newBooking: NewBookingState;
  booking: Booking;
  userProfile: UserProfile;
  insuranceProfiles: InsuranceProfile[];
}

export const usePreloadedData = (): PreloadedData => {
  const bookingId = usePaperworkContextBookingId();
  const accountSummary = useSelector((state) => state.account.summary);
  const booking = useSelector((state) => state.pastBookings[bookingId] || {});
  const newBooking = useSelector((state) => state.newBooking);
  const userProfile = useMemo(
    () => getProfileFromBooking(accountSummary, booking) || {},
    [accountSummary, booking]
  );
  const insuranceProfileId = userProfile.insurance_profile_id;
  const insuranceProfiles =
    accountSummary?.insurance_profiles
      ?.sort((a: InsuranceProfile, b: InsuranceProfile) => {
        if (a.insurance_profile_id === insuranceProfileId) {
          return -1;
        }
        return +moment(b.updated_date) - +moment(a.updated_date);
      })
      .slice(0, 8) || [];

  return {
    newBooking,
    booking,
    userProfile,
    insuranceProfiles,
  };
};
